import { useQuery } from '@tanstack/react-query';
import { BENEFICIARY_DEPENDENTS_KEY } from '../../utils/constants/queryKeys';
import { getDependents } from '../services/fn-api/Beneficiary';

export const useGetDependents = (beneId: number) => {
  return useQuery({
    queryKey: [BENEFICIARY_DEPENDENTS_KEY, beneId],
    queryFn: () => getDependents(beneId),
    enabled: !!beneId,
  });
};
